import * as actions from '../actions'

const defaultState = null

export default function unknownCategory(state = defaultState, action) {
    switch (action.type) {
        case actions.UNKNOWN_CATEGORY_GET:
            let newState = state
            if (!action.error) {
                newState = action.payload.data.objects
            }
            return newState

        case actions.UNKNOWN_CATEGORY_CLEAN:
            return defaultState

        default:
            return state
    }
}
